module.exports = __webpack_public_path__ + "img/apple-icon-57x57.08c39d79.png";